import { manufacturingFetch } from "@/lib/manufacturingClient";

export type MfgRecipeGroupSummary = {
  id: string;
  code: string;
  name: string;
  notes: string;
  created_at: string;
  updated_at: string;
};

export function listManufacturingRecipeGroups() {
  return manufacturingFetch<{ ok: true; groups: MfgRecipeGroupSummary[] }>(
    "/api/mfg/recipe-groups",
    { method: "GET" }
  );
}

export function createManufacturingRecipeGroup(payload: {
  code: string;
  name: string;
  notes?: string;
}) {
  return manufacturingFetch<{ ok: true; group: MfgRecipeGroupSummary }>(
    "/api/mfg/recipe-groups/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function updateManufacturingRecipeGroup(payload: {
  recipe_group_id: string;
  code?: string;
  name?: string;
  notes?: string;
}) {
  return manufacturingFetch<{ ok: true; group: MfgRecipeGroupSummary }>(
    "/api/mfg/recipe-groups/update",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}
